import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAuth from './auth.reducer';
import { AuthEffects } from './auth.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.reducers, {
            metaReducers: fromAuth.metaReducers,
        }),
        EffectsModule.forFeature([AuthEffects]),
    ],
})
export class AuthModule {}

export * as AuthActions from './auth.actions';
export * as AuthSelectors from './auth.selectors';
